import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ComponentsBaseModule } from "src/app/shared/components/components.module";
import { ModalModule } from "src/app/shared/components/modal/modal.module";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
    imports: [
        BrowserModule,
        SharedModule,
        ModalModule,
        ComponentsBaseModule,
    ],
    declarations: [
    ],
    exports: [
    ],
})
export class CommonConsumption { }
